export const DemoSources = {
  DEMO_CONS: "DEMO_CONS",
  DEMO_PROD: "DEMO_PROD"
}



// WEBPACK FOOTER //
// ./src/enums/DemoSources.js